import { lazy } from 'react';

const CustomActiu = lazy(() => import('./CustomActiu'));

export default CustomActiu;
